module.exports = __webpack_public_path__ + "static/img/050.48849b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/050.png
// module id = Xri8
// module chunks = 0